import DynamicFilter from '../dynamicFilter/DynamicFilter';

export default function FiltersPanel({
  filters,
  selectedCategory,
  selectedHashtag,
  selectedLocation,
  selectedSubcategory,
  selectedOpportunity,
  selectedDateRange,
  selectedSegment,
  selectedDateLabel,
  selectedDatehistory,
  customStartDate,
  customEndDate,
  hashtagFilterLetters,
  hashtagFilterNumbers,
  hashtagFilterEmojis,
  hashtagFilterEnglish,

  onCategoryChange,
  onHashtagChange,
  onLocationChange,
  onSubcategoryChange,
  onOpportunityChange,
  onSegmentChange,
  onDateChange,
  onDateRangeChange,
  onDatehistoryChange,
  onCustomStartDateChange,
  onCustomEndDateChange,
  onHashtagFilterLettersChange,
  onHashtagFilterNumbersChange,
  onHashtagFilterEmojisChange,
  onHashtagFilterEnglishChange,
  onClearAllFilters,
  updateQSParameter, 
  maxDate,
  getAllSubcategories,
  getFilteredHashtagOptions,
  getFilteredSegmentOptions
}) {

  return (
  <aside className="bg-black text-white filters-panel filters-panel-aside">
          
    <h4 className="text-lg font-oswald-bold uppercase pb-2 mb-[5px] flex-shrink-0 filters-panel-header">
      Filters
    </h4>

    <div className="flex-1 filters-content">

                    {/* hashtag filter with content type checkboxes */}
                    {Array.isArray(filters?.Hashtag?.options) && filters.Hashtag.options.length > 0 && (
                      <div className="hashtag-filter-group">
                        
                        {/* Hashtag content type filter checkboxes */}
                        <div className="hashtag-filter-label">
                          <div>Filter Hashtag Characters:</div>
                          
                          <div className="hashtag-checkbox-container">

                            <label className="hashtag-checkbox-label">
                              <input
                                type="checkbox"
                                checked={hashtagFilterEnglish}
                                onChange={(e) => onHashtagFilterEnglishChange(e.target.checked)}
                                className="hashtag-checkbox"
                              />
                              English
                            </label>

                            <label className="hashtag-checkbox-label">
                              <input
                                type="checkbox"
                                checked={hashtagFilterLetters}
                                onChange={(e) => onHashtagFilterLettersChange(e.target.checked)}
                                className="hashtag-checkbox"
                              />
                              Multi-Lingual
                            </label>
                            
                            <label className="hashtag-checkbox-label">
                              <input
                                type="checkbox"
                                checked={hashtagFilterNumbers}
                                onChange={(e) => onHashtagFilterNumbersChange(e.target.checked)}
                                className="hashtag-checkbox"
                              />
                              Numbers
                            </label>
                            
                            <label className="hashtag-checkbox-label">
                              <input
                                type="checkbox"
                                checked={hashtagFilterEmojis}
                                onChange={(e) => onHashtagFilterEmojisChange(e.target.checked)}
                                className="hashtag-checkbox"
                              />
                              Emojis
                            </label>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="filter-control">                      
                        <DynamicFilter
                            type="autocomplete"
                            label="Hashtag"
                            options={(getFilteredHashtagOptions ? getFilteredHashtagOptions() : filters?.Hashtag?.options || []).sort((a, b) => 
                              (a.label || a.value || '').localeCompare(b.label || b.value || '')
                            )}
                            value={selectedHashtag.filter(val => val !== 'ALL_VALUES')}
                            onChange={onHashtagChange}
                            multiple
                        />
                    </div>  

                    {/* Location filter */}
                    {Array.isArray(filters?.Location?.options) && filters.Location.options.length > 0 && (
                        <div className="filter-control">
                          <DynamicFilter

                              label="Location"
                              options={(filters?.Location?.options || []).sort((a, b) => 
                                (a.label || a.value || '').localeCompare(b.label || b.value || '')
                              )}
                              value={selectedLocation.filter(val => val !== 'ALL_VALUES')}
                              onChange={onLocationChange}
                              multiple
                          />
                        </div>
                    )}

                    {/* Category filter */}
                    {Array.isArray(filters?.Category?.options) && filters.Category.options.length > 0 && (
                        <div className="filter-control">
                          <DynamicFilter
                              label="Categories"
                              options={(filters?.Category?.options || []).sort((a, b) => 
                                (a.label || a.value || '').localeCompare(b.label || b.value || '')
                              )}
                              value={selectedCategory.filter(val => val !== 'ALL_VALUES')}
                              onChange={onCategoryChange}
                              multiple
                          />
                        </div>
                    )}

                    {/* Subcategory filter with hybrid functionality */}
                    <div className="filter-control">
                      <DynamicFilter

                          label="Subcategory"
                          options={
                              (Array.isArray(selectedCategory) && selectedCategory.length > 0
                                  ? selectedCategory.reduce((acc, categoryValue) => {
                                      const categoryOptions = filters?.Subcategory?.optionsByCategory[categoryValue] || [];
                                      return [...acc, ...categoryOptions];
                                    }, [])
                                  : (getAllSubcategories ? getAllSubcategories() : [])
                              ).sort((a, b) => 
                                (a.label || a.value || '').localeCompare(b.label || b.value || '')
                              )
                          }
                          value={selectedSubcategory.filter(val => val !== 'ALL_VALUES')}
                          onChange={onSubcategoryChange}
                          multiple
                      />
                    </div>


                    {/* Segment filter */}
                    {Array.isArray(filters?.Segment?.options) && filters.Segment.options.length > 0 && (
                        <div className="filter-control">
                          <DynamicFilter
                              label="Segment"
                              options={(getFilteredSegmentOptions ? getFilteredSegmentOptions() : filters?.Segment?.options || []).sort((a, b) => 
                                (a.label || a.value || '').localeCompare(b.label || b.value || '')
                              )}
                              value={selectedSegment.filter(val => val !== 'ALL_VALUES')}
                              onChange={onSegmentChange}
                              multiple
                          />
                        </div>
                    )}


                    {/* Opportunity Score filter */}
                    {Array.isArray(filters?.OpportunityScore?.options) && filters.OpportunityScore.options.length > 0 && (
                        <div className="filter-control">
                          <DynamicFilter
                              label="Opportunity Score"
                              options={filters?.OpportunityScore?.options || []}
                              value={selectedOpportunity.filter(val => val !== 'ALL_VALUES')}
                              onChange={onOpportunityChange}
                              multiple
                          />
                        </div>
                    )}


                    {/* Date pull-down list filter */}
                    <div className="date-controls-group">
                      {Array.isArray(filters?.DateRange?.options) && filters.DateRange.options.length > 0 && (
                        <div className="filter-control">
                          <DynamicFilter
                            label="Date Range"
                            options={filters?.DateRange?.options || []}
                            value={selectedDatehistory.filter(val => val !== 'ALL_VALUES')}
                            onChange={onDatehistoryChange}
                            multiple={false}
                          />
                        </div>
                      )}


                      {/* Custom Start Date Picker */}
                      <div className="date-control">
                        <DynamicFilter
                          type="date"
                          label="Start Date"
                          value={customStartDate}
                          onChange={onCustomStartDateChange}
                          maxDate={maxDate}
                        />
                      </div>

                      {/* Custom End Date Picker */}
                      <div className="date-control">
                        <DynamicFilter
                          type="date"
                          label="End Date"
                          value={customEndDate} 
                          onChange={onCustomEndDateChange}
                          maxDate={maxDate}
                        />
                      </div>
                    </div>

      <button
        className="font-oswald-bold text-sm rounded transition-colors flex-shrink-0 reset-filters-btn"
        onClick={onClearAllFilters}
      >
        Reset All Filters
      </button>
    </div>
    </aside>
  );
}